import { useHistory } from 'react-router-dom';

import phone from '../../../../../../assets/icons/phone.png';
import watch from '../../../../../../assets/icons/watch.png';

import { Container, NameLatestPodcastSerie } from './styles';

const CardLatestPodcastSerieReleased = ({
  featuredPodcast,
  featuredPodcastLessons,
}) => {
  const history = useHistory();
  // function renderDuration() {
  //   const { duration } = featuredPodcast;
  //   if (duration > 0) {
  //     if (duration < 60) {
  //       return `${duration} min`;
  //     } else {
  //       const hours = Math.trunc(duration / 60);
  //       const minutes = Math.trunc(duration - 60 * hours);
  //       if (hours === 1) {
  //         return `${hours} hora ${minutes > 0 ? ` e ${minutes} minutos` : ``}`;
  //       }
  //       return `${hours} horas ${minutes > 0 ? ` e ${minutes} minutos` : ``}`;
  //     }
  //   }
  // }

  function renderNumberEpisodes() {
    if (featuredPodcastLessons.length > 1) {
      return `${featuredPodcastLessons.length} áudios`;
    } else if (featuredPodcastLessons.length === 1) {
      return `${featuredPodcastLessons.length} áudio`;
    } else {
      return 'Nenhum episódio';
    }
  }

  function renderComponent() {
    if (JSON.stringify(featuredPodcast) !== '{}') {
      return (
        <Container>
          <NameLatestPodcastSerie
            onClick={() =>
              history.push({
                pathname: `/podcast/${featuredPodcast.id}`,
              })
            }
          >
            {' '}
          </NameLatestPodcastSerie>
          <img
            src={featuredPodcast.thumbnail_url}
            alt="Thumbnail da série do podcast"
          />
          <div
            onClick={() =>
              history.push({
                pathname: `/podcast/${featuredPodcast.id}`,
              })
            }
          >
            <ul>
              <li>{renderNumberEpisodes()}</li>
            </ul>
          </div>
        </Container>
      );
    }
  }

  return <>{renderComponent()}</>;
};

export default CardLatestPodcastSerieReleased;
